/* eslint-disable no-param-reassign */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { FileImportItem } from "./types";

const name = "fileImportActivity";

type FileImportActivityState = {
  byId: Record<string, FileImportItem>;
  pageMap: Record<string, string[]>;
  total: number;
};

const initialState: FileImportActivityState = {
  byId: {},
  pageMap: {},
  total: 0,
};

const slice = createSlice({
  name,
  initialState,
  reducers: {
    upsertPage: (
      state,
      action: PayloadAction<{
        pageNumber: number;
        results: FileImportItem[];
        total: number;
      }>,
    ) => {
      const { results, total, pageNumber } = action.payload;

      results.forEach((item: FileImportItem) => {
        state.byId[item.id] = item;
      });

      state.pageMap[pageNumber] = results.map(
        (item: FileImportItem) => item.id,
      );
      state.total = total;
    },

    resetState: (state) => {
      Object.assign(state, initialState);
    },
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
